<template>
  <MenuItem v-slot="{ active }">
    <button
      @click="click"
      :class="[
        active ? ' text-gray-900 dark:text-white' : 'text-gray-700 dark:text-gray-300',
        'group flex w-full items-center rounded-md  py-2 text-sm transition-all',
      ]"
    >
      <span class="whitespace-nowrap w-full">
        <slot></slot>
      </span>
    </button>
  </MenuItem>
</template>

<script setup lang="ts">
import { MenuItem } from "@headlessui/vue";

const emit = defineEmits(["click"]);

const click = () => {
  emit("click");
};
</script>
